var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsAddProd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 51,
    viewBox: "0 0 53 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8432 5.82322C6.31823 8.87105 1.80886 11.45 1.80886 11.5672C1.76824 11.6844 6.35885 14.3025 11.9651 17.3894C19.8463 21.7267 22.3245 22.938 22.8526 22.6254C23.2182 22.43 27.7682 19.9292 32.9682 17.0377C38.1276 14.1462 42.3932 11.7235 42.3932 11.5672C42.3932 11.3328 22.4463 0.235523 22.0807 0.274597C21.9588 0.274597 17.3682 2.77538 11.8432 5.82322Z",
    fill: "#1B4597"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.554688 25.323V36.7719L8.35468 41.0701C12.6203 43.4146 17.2109 45.9545 18.5109 46.6578L20.8672 47.9473V36.4983L20.8265 25.0494L13.0672 20.7512C8.80155 18.3676 4.21093 15.8669 2.91093 15.1635L0.554688 13.874V25.323Z",
    fill: "#1B4597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.466 19.5371L23.5129 25.0857L23.391 36.5346C23.3504 42.8257 23.4316 47.9054 23.6348 47.8272C23.7973 47.7882 25.5035 46.8504 27.4129 45.8344L30.8254 43.9588L30.866 40.9501C30.866 38.6056 31.1098 37.5115 31.841 35.9876C33.791 32.1582 37.4879 29.6184 41.6722 29.2667L44.0285 29.0323V21.4908C44.0285 17.3098 43.9066 13.9103 43.7441 13.9494C43.541 13.9494 38.9504 16.4892 33.466 19.5371Z",
    fill: "#1B4597"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8003 32.0414C37.5659 32.8619 35.494 34.5812 34.3972 36.574C33.3003 38.5278 33.1378 42.4353 33.9909 44.5062C36.5909 50.3674 44.5534 52.0477 49.6315 47.7494C51.6221 46.0692 52.5565 43.9201 52.5565 40.9504C52.5565 38.2152 51.9878 36.574 50.3221 34.6984C48.0065 32.0414 43.1721 30.83 39.8003 32.0414ZM44.4315 37.7463V39.7H46.2596C48.0065 39.7 48.0878 39.7391 48.0878 40.8723C48.0878 42.0054 48.0065 42.0445 46.2596 42.0445H44.4315V43.9982V45.952H43.0096H41.5878V43.9982V42.0445H39.7597C38.0128 42.0445 37.9315 42.0054 37.9315 40.8723C37.9315 39.7391 38.0128 39.7 39.7597 39.7H41.5878V37.7463V35.7925H43.0096H44.4315V37.7463Z",
    fill: "#1B4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsAddProd);
export default __webpack_public_path__ + "static/media/IsAddProd.d28158711e2db4b3c19e17c0ad1222ea.svg";
export { ForwardRef as ReactComponent };